const isMaintenanceDate = (startDate: string, endDate: string) => {
  const today = new Date();
  const start = new Date(startDate);
  const end = new Date(endDate);

  return today >= start && today <= end;
};
const isMaintenanceCountry = (docCountry: string, countryList: string[]) => {
  const country = docCountry;
  return countryList.includes(country);
};

export const isSiteUnderMaintainance = (
  startDate: string,
  endDate: string,
  docCountry: string,
  countryList: string[]
) => {
  return (
    isMaintenanceDate(startDate, endDate) &&
    isMaintenanceCountry(docCountry, countryList)
  );
};

export const REDIRECT_COUNTRIES = [
  { country: 'BR', url: 'https://www.alignstore.com.br/' },
];

export const isDoctorNeedToRedirect = (docCountry?: string) =>
  REDIRECT_COUNTRIES.some(country => country.country === docCountry);

export const redirectURL = (docCountry?: string) =>
  REDIRECT_COUNTRIES.find(country => country.country === docCountry)?.url;
